import { staticText } from '../../utils/translations/staticText';

export const TRANSLATIONS = staticText({
  scenario_accordion_module_title: {
    _: 'Which Option Suits You?',
    zh: '哪個選項最適合你？',
  },
});

export type ScenarioAccordionTranslations = typeof TRANSLATIONS;
